<script setup lang="ts">
defineProps({
	muted: {
		type: Boolean,
		default: false,
	},
});
</script>

<template>
	<svg
		width="30px"
		height="30px"
		viewBox="-16 -17 60 60"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g v-if="!muted" stroke="none" stroke-width="1" fill-rule="evenodd">
			<g
				id="Icon-Set"
				transform="translate(-256.000000, -569.000000)"
				fill="#fff"
			>
				<path
					id="volume-full"
					d="M270,593 L263,588.625 L263,577.375 L270,573 L270,593 L270,593 Z M261,586 C261,586.553 260.552,587 260,587 L259,587 C258.448,587 258,586.553 258,586 L258,580 C258,579.448 258.448,579 259,579 L260,579 C260.552,579 261,579.448 261,580 L261,586 L261,586 Z M270,571 L261,577 L258,577 C256.896,577 256,577.896 256,579 L256,587 C256,588.104 256.896,589 258,589 L261,589 L270,595 C271.104,595 272,594.104 272,593 L272,573 C272,571.896 271.104,571 270,571 L270,571 Z M281,583 C281,579.477 278.388,576.59 275,576.101 L275,578.101 C277.282,578.564 279,580.581 279,583 C279,585.419 277.282,587.436 275,587.899 L275,589.899 C278.388,589.41 281,586.523 281,583 L281,583 Z M275,569.015 L275,571.068 C280.872,572.199 285,576.988 285,583 C285,588.978 281,593.609 275,594.932 L275,596.986 C281.776,595.994 287,590.143 287,583 C287,575.857 281.776,570.006 275,569.015 L275,569.015 Z"
				></path>
			</g>
		</g>
		<g
			v-if="muted"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Icon-Set"
				transform="translate(-309.000000, -571.000000)"
				fill="#fff"
			>
				<path
					id="volume-muted"
					d="M323,593 L316,588.625 L316,577.375 L323,573 L323,593 L323,593 Z M314,586 C314,586.553 313.553,587 313,587 L312,587 C311.447,587 311,586.553 311,586 L311,580 C311,579.448 311.447,579 312,579 L313,579 C313.553,579 314,579.448 314,580 L314,586 L314,586 Z M323,571 L314,577 L311,577 C309.896,577 309,577.896 309,579 L309,587 C309,588.104 309.896,589 311,589 L314,589 L323,595 C324.104,595 325,594.104 325,593 L325,573 C325,571.896 324.104,571 323,571 L323,571 Z M334.444,583 L338.617,578.827 C339.067,578.377 339.109,577.688 338.711,577.289 C338.312,576.891 337.623,576.933 337.173,577.383 L333,581.556 L328.827,577.383 C328.377,576.933 327.688,576.891 327.289,577.289 C326.891,577.688 326.933,578.377 327.383,578.827 L331.556,583 L327.383,587.173 C326.933,587.623 326.891,588.312 327.289,588.711 C327.688,589.109 328.377,589.067 328.827,588.617 L333,584.444 L337.173,588.617 C337.623,589.067 338.312,589.109 338.711,588.711 C339.109,588.312 339.067,587.623 338.617,587.173 L334.444,583 L334.444,583 Z"
				></path>
			</g>
		</g>
	</svg>
</template>
